import { Injectable } from "@angular/core";

import { datesToDb, dbToDates, dbToInts, intsToDb } from "@dffedb/util";
import { MaalerAflaesningDbMapper } from "@e-forsyning/common/maaler";

import { InstallationsoprettelseDataDto } from "./model/installationsoprettelse-data.dto";
import { InstallationsoprettelseData } from "./model/installationsoprettelse-data.model";
import { InstallationsoprettelseDto } from "./model/installationsoprettelse.dto";
import { Installationsoprettelse } from "./model/installationsoprettelse.model";

@Injectable({ providedIn: "root" })
export class InstallationsoprettelseMapper {
    constructor(private readonly maalerAflaesningDbMapper: MaalerAflaesningDbMapper) {}

    public dtoToInstallationsoprettelseData(data: InstallationsoprettelseDataDto, bilagUrlTemplate: string): InstallationsoprettelseData {
        const result: InstallationsoprettelseData = {
            ...data,
            installationsoprettelse: this.dtoToInstallationsoprettelse(data.installationsoprettelse, bilagUrlTemplate)
        };
        return result;
    }

    public dtoToInstallationsoprettelse(data: InstallationsoprettelseDto, bilagUrlTemplate: string): Installationsoprettelse {
        const nyMaaler = this.maalerAflaesningDbMapper.dbToMaalerAflaesningMedNoter(data.nyMaaler, bilagUrlTemplate);
        const result: Installationsoprettelse = {
            nyMaaler,
            dato: dbToDates(data.dato),
            huskelisteId: dbToInts(data.huskelisteId),
            info1: data.info1,
            info2: data.info2
        };
        return result;
    }

    public installationsoprettelsDataToDto(data: InstallationsoprettelseData): InstallationsoprettelseDataDto {
        const result: InstallationsoprettelseDataDto = {
            installationsoprettelse: this.installationsoprettelseToDto(data.installationsoprettelse)
        };
        return result;
    }

    public installationsoprettelseToDto(data: Installationsoprettelse): InstallationsoprettelseDto {
        const result: InstallationsoprettelseDto = {
            dato: datesToDb(data.dato),
            huskelisteId: intsToDb(data.huskelisteId),
            info1: data.info1,
            info2: data.info2,
            nyMaaler: this.maalerAflaesningDbMapper.maalerAflaesningMedNoterToDb(data.nyMaaler)
        };
        return result;
    }
}
